// src/services/api.js

import axios from "axios";

let csrfToken = null;

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

/**
 * Fetch a fresh CSRF token from the backend.
 */
async function fetchCsrfToken() {
    console.log("Fetching CSRF token...");
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/csrf/token`,
        {
            withCredentials: true,
        }
    );

    csrfToken = response.data.csrfToken;

    return csrfToken;
}

/**
 * Request Interceptor
 * Automatically attaches the CSRF token before every request.
 */
api.interceptors.request.use(
    async (config) => {
        if (!csrfToken) {
            await fetchCsrfToken();
        }

        config.headers["X-CSRF-Token"] = csrfToken;

        return config;
    },
    (error) => Promise.reject(error)
);

/**
 * Response Interceptor
 * If the CSRF token has expired, fetch a new one and retry once.
 */
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (
            error.response?.status === 403 &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true;

            try {
                await fetchCsrfToken();

                originalRequest.headers["X-CSRF-Token"] = csrfToken;

                return api(originalRequest);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;